module.exports = __webpack_public_path__ + "static/media/bara-in-house.2e878937.jpg";